export const shouldLoad = () => !!document.querySelector('.klt-fields-select-field');
